import { API_WEB_FULLERETTE } from "@/config"
import { StatusCode, type AdUserByPhoneResponse } from "@/types"

type AdUserByPhoneResult = {
    status: StatusCode
    data: AdUserByPhoneResponse
}

export async function adUserByPhone(phoneNumber: string): Promise<AdUserByPhoneResult> {
    try {
        const query = new URLSearchParams({ phoneNumber })
        const response = await fetch(`${API_WEB_FULLERETTE}AdUserByPhone?${query.toString()}`)

        const contentType = response.headers.get("content-type") ?? ""
        const data = contentType.includes("application/json")
            ? await response.json() as AdUserByPhoneResponse
            : {
                Message: "No se pudo interpretar la respuesta del servidor",
                Response: false,
            } satisfies AdUserByPhoneResponse

        return {
            status: response.status as StatusCode,
            data,
        }
    } catch (error) {
        console.error("adUserByPhone error:", error)

        return {
            status: StatusCode.FATAL_ERROR,
            data: {
                Message: "No se pudo conectar al servidor",
                Response: false,
            },
        }
    }
}
